import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const AuditTypeSectionForm = forwardRef(({type, section, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={section}
      type="section"
      fieldsComponent={(props) => <Fields {...props}/>}
      onSave={({id, title}) => services.auditType.section.saveSection(type, {id, title})}
      onSaved={onSaved}
    />
  );
});

export default AuditTypeSectionForm;
